import { render } from "./AdsCreating.vue?vue&type=template&id=4ebc9224&ts=true"
import script from "./AdsCreating.vue?vue&type=script&lang=ts"
export * from "./AdsCreating.vue?vue&type=script&lang=ts"

import "./AdsCreating.vue?vue&type=style&index=0&id=4ebc9224&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__